import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Img } from './data/img';
import { Page } from './data/page';
import { Projet } from './data/projet';
import { Categorie } from './data/categorie';
import { Article } from './data/article';
import { Menu } from './data/menu';
import { User } from './data/user';
import { Message } from './data/message';
import { AuthService } from '../auth/auth.service';
import { Publication } from './data/publication';
import { Permission } from './data/permission';
import { Souscription } from './data/souscription';
import { Critere } from './data/critere';
import { Formation } from './data/formation';
import { Ecole } from './data/ecole';
import { Admission } from './data/admission';
import { Faculte } from './data/faculte';
import { Metier } from './data/metier';
import { Job } from './data/job';
import { Settings } from './data/settings';
import { LicenceKey } from './data/licencekey';
import { Device } from './data/device';
import { Database } from './data/database.model';
import { Offre } from './data/offre';

@Injectable()
export class ApiService {

  constructor(private httpClient: HttpClient, public authService: AuthService,) { }

  
  getOneUserProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
     
        'X-Auth-Token': this.authService.token.value    
      })
    };
    return this.httpClient.get(Config.apiUrl+ 'admin/users'+'/'+id,httpOptions);
  }


  getAllUserProvider(){

    const httpOptions = {
      headers: new HttpHeaders({
     
        'X-Auth-Token': this.authService.token.value    
      })
    };
    return this.httpClient.get<User[]>(Config.apiUrl+ 'admin/users',httpOptions);
  }


  deleteUserProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
     
        'X-Auth-Token': this.authService.token.value    
      })
    };
    return this.httpClient.delete(Config.apiUrl+ 'admin/users'+'/'+id,httpOptions);
  }




//   formData.append("filedata", this.selectedFile);
//   formData.append("username",this.usernam);
  
//   formData.append("nom",this.nome);
//   formData.append("prenom",this.prenome);
//   formData.append("plainPassword",this.plainPass);
//   formData.append("email",this.emaile);
//   formData.append("civility",this.civility);
//   formData.append("addresse",this.adress);


//   formData.append('dateNaissance[date][year]', this.model.year);
//  formData.append('dateNaissance[date][month]',this.model.month);
//   formData.append('dateNaissance[date][day]', this.model.day);
 
//   formData.append('dateNaissance[time][hour]', this.heure);
//   formData.append('dateNaissance[time][minute]', this.minute);



  createUserProvider(user: User){
    
    let formData:FormData = new FormData();

    if( user.selectedPhotoFile !== undefined)
    formData.append("filedata", user.selectedPhotoFile);

    formData.append("username", user.username);
  
    formData.append("nom", user.nom);
    formData.append("prenom", user.prenom);

    if( user.plainPassword !== undefined && user.plainPassword !== null)
    formData.append("plainPassword", user.plainPassword);

    formData.append("email", user.email);
    formData.append("civility", user.civility);
    formData.append("adresse", user.adresse);

    formData.append("telephone", user.telephone);

    if( user.date_naissance !== undefined && user.date_naissance !== null) {

      formData.append('dateNaissance[year]', user.date_naissance.year);
      formData.append('dateNaissance[month]', user.date_naissance.month);
      formData.append('dateNaissance[day]', user.date_naissance.day);

    }

    // gestion des permissions
    if(user.permissions !== undefined) {

      user.permissions.forEach(element => {

        formData.append('permissions[]', element.value);

      });

    }
    

    const httpOptions = {
      headers: new HttpHeaders({
        
      }).delete('Content-Type')
    };
  
    return this.httpClient.post(Config.apiUrl +'users', formData,  httpOptions );
  
  }


  updateUserProvider(user: User){

    let formData:FormData = new FormData();

    if( user.selectedPhotoFile !== undefined)
    formData.append("filedata", user.selectedPhotoFile);

    formData.append("username", user.username);

    formData.append("isActive", JSON.stringify(user.is_active));
  
    formData.append("nom", user.nom);
    formData.append("prenom", user.prenom);

    if( user.plainPassword !== undefined && user.plainPassword !== null)
    formData.append("plainPassword", user.plainPassword);

    formData.append("email", user.email);
    formData.append("civility", user.civility);
    formData.append("adresse", user.adresse);

    formData.append("telephone", user.telephone);

    if( user.date_naissance !== undefined && user.date_naissance !== null) {

      formData.append('dateNaissance[year]', user.date_naissance.year);
      formData.append('dateNaissance[month]', user.date_naissance.month);
      formData.append('dateNaissance[day]', user.date_naissance.day);

    }

    // gestion des permissions
    if(user.permissions !== null && user.permissions !== undefined) {

      user.permissions.forEach(element => {

        formData.append('permissions[]', element.value);
        
      });

    }
    

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value   
      }).delete('Content-Type')
    };
 
    return this.httpClient.post(Config.apiUrl +'admin/users'+'/'+user.id, formData,  httpOptions );

  }

  activeUserProvider(user: User){

    const body=  {
      isActive: user.is_active,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        
        'X-Auth-Token': this.authService.token.value  ,
        'Content-Type':  'application/json'     
      })
    };

    var donnees = JSON.stringify(body);

 
    return this.httpClient.patch(Config.apiUrl +'admin/users/'+ user.id, donnees,  httpOptions );

  }


  addCategorieProvider(cat: Categorie){

    let idparent = null;

    if(cat.parent !== undefined && cat.parent !== null)
    idparent = cat.parent.id;
  
    const body=  {
      nom: cat.nom,
      parent:idparent,
      description: cat.description,
      typeContent: cat.type_content,
              
    };
    
    const httpOptions = {
      headers: new HttpHeaders({
        
        'X-Auth-Token': this.authService.token.value  ,
        'Content-Type':  'application/json'     
      })
    };

    var donnees = JSON.stringify(body);
    
    return this.httpClient.post(Config.apiUrl+ 'admin/categories', donnees,httpOptions);
  
  }

  deleteCategoryProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.delete(Config.apiUrl+ 'admin/categories'+'/'+id,httpOptions);

  }

  getOneCategoryProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get(Config.apiUrl+ 'admin/categories'+'/'+id,httpOptions);

  }

  getAllCategoryProvider(type: string){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Categorie[]>(Config.apiUrl+ 'admin/categories?type=' + type, httpOptions);

  }

  getAllPermissionsProvider(){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Permission[]>(Config.apiUrl+ 'admin/permissions', httpOptions);

  }


  updateCategoryProvider(cat: Categorie){

    let idparent = null;

    if(cat.parent !== undefined && cat.parent !== null)
    idparent = cat.parent.id;
   
    const body=  {
      nom: cat.nom,
      parent:idparent,
      description: cat.description,
      typeContent: cat.type_content,
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
    
   return this.httpClient.patch(Config.apiUrl+ 'admin/categories'+'/'+cat.id,donnees,httpOptions);
  }



  updateAllCategoryProvider(id,nm,pr?,des?){

   
    const body=  {
      nom: nm,
      parent:pr,
      description: des,
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
    
   return this.httpClient.patch(Config.apiUrl+ 'admin/categories'+'/'+id,donnees,httpOptions);
  }



  updateMenuProvider(id,contenu?, name?){

    const body=  {
      
    items:JSON.stringify(contenu)
               
     };
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
      })
    };

    // var donnees = JSON.stringify(body);

    
   return this.httpClient.patch(Config.apiUrl+ 'admin/menus'+'/'+id,body,httpOptions);
  }

  createMenuProvider(nm){

    

    const body=  {
      nom: nm,
     
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
     
    return this.httpClient.post(Config.apiUrl+ 'admin/menus',donnees,httpOptions);
   }


   deleteMenuProvider(id){

   
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value    
       })
     };
     
    return this.httpClient.delete(Config.apiUrl+ 'admin/menus'+'/'+id,httpOptions);
   }


   getAllMenuProvider(){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get<Menu[]>(Config.apiUrl+ 'admin/menus',httpOptions);
  }


  getOneMenuProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get(Config.apiUrl+ 'admin/menus'+'/'+id,httpOptions);
  }

  activePublicationProvider(idpub: number, publish: boolean){

    const body=  {
      /* titre: page.titre,
      description: page.description,
      slug: page.slug,
      isPublish: page.is_publish,
      datePublish: page.date_publish,
      photoSelected: page.photo,
      shortTitle: page.short_title,
      parent: page.idparent,
      videoYoutube: page.video_youtube,
      fichierSelected: page.fichier, */
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);

     let ispublish = 0;
     if(publish)
     ispublish = 1;
     
     return this.httpClient.patch(Config.apiUrl+ 'admin/publication/'+ idpub + '/setpublish?ispublish=' + ispublish, donnees, httpOptions);
   }


   deleteArticleProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.delete(Config.apiUrl+ 'admin/articles'+'/'+id,httpOptions);

  }


  getArticleProvider(type){

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<any>(Config.apiUrl+ 'admin/articles?type=' + type,httpOptions);

  }


  getOneArticleProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get(Config.apiUrl+ 'admin/articles'+'/'+id,httpOptions);
  }



 addArticleProvider(art: Article){

  

      let id_cat: number[];
      id_cat = [];

      if ( art.categories !== undefined && art.categories !== null) {
        for ( let i = 0; i < art.categories.length; i++) {
          id_cat.push(art.categories[i].id);
        }
      }


      const body=  {
        titre: art.titre,
        description: art.description,
        slug: art.slug,
        isPublish: art.is_publish,
        datePublish: art.date_publish,
        photoSelected: art.photo,
        categories: id_cat,
        typeArticle: art.type_article,
        videoYoutube: art.video_youtube,
                
      };
    
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
     console.log(donnees);
    return this.httpClient.post(Config.apiUrl+ 'admin/articles',donnees,httpOptions);
   }




   updateArticleProvider(art: Article){

  

    let id_cat: number[];
    id_cat = [];

    if ( art.categories !== undefined && art.categories !== null) {
      for ( let i = 0; i < art.categories.length; i++) {
        id_cat.push(art.categories[i].id);
      }
    }


    const body=  {
      titre: art.titre,
      description: art.description,
      slug: art.slug,
      isPublish: art.is_publish,
      datePublish: art.date_publish,
      photoSelected: art.photo,
      categories: id_cat,
      typeArticle: art.type_article,
      videoYoutube: art.video_youtube,
               
     };

     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
     
    return this.httpClient.patch(Config.apiUrl+ 'admin/articles'+'/'+art.id,donnees,httpOptions);
   }



   deletePageProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.delete(Config.apiUrl+ 'admin/pages'+'/'+id,httpOptions);
  }

  deleteProjetProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.delete(Config.apiUrl+ 'admin/projets'+'/'+id,httpOptions);
  }



  addPageProvider(page: Page){

  

    const body=  {
      titre: page.titre,
      description:page.description,
      slug: page.slug,
      isPublish:page.is_publish,
      datePublish:page.date_publish,
      photoSelected:page.photo,
      shortTitle: page.short_title,
      parent: page.idparent,
      videoYoutube: page.video_youtube,
      fichierSelected: page.fichier,
      //categories:cat
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
     console.log(donnees);
    return this.httpClient.post(Config.apiUrl+ 'admin/pages',donnees,httpOptions);
   }

  
   updatePageProvider(page: Page){

     const body =  {

      titre: page.titre,
      description: page.description,
      slug: page.slug,
      isPublish: page.is_publish,
      datePublish: page.date_publish,
      photoSelected: page.photo,
      shortTitle: page.short_title,
      parent: page.idparent,
      videoYoutube: page.video_youtube,
      fichierSelected: page.fichier,
      backgroundColor: page.background_color,
  
     };

     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };

     var donnees = JSON.stringify(body);
     
     return this.httpClient.patch(Config.apiUrl+ 'admin/pages'+'/'+ page.id,donnees,httpOptions);

   }

   addProjetProvider(projet: Projet){

    let images = null;
    if( projet.images !== null && projet.images !== undefined && projet.images.length !== 0)
    images = projet.images;
  
    let id_cat: number[];
    id_cat = [];

    if ( projet.categories !== undefined && projet.categories !== null) {
      for ( let i = 0; i < projet.categories.length; i++) {
        id_cat.push(projet.categories[i].id);
      }
    }

    const body=  {
      titre: projet.titre,
      description: projet.description,
      slug: projet.slug,
      isPublish: projet.is_publish,
      datePublish: projet.date_publish,
      photoSelected: projet.photo,
      imagesSelected: images,
      categories: id_cat,
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
     console.log(donnees);
    return this.httpClient.post(Config.apiUrl+ 'admin/projets',donnees,httpOptions);
  }




   updateProjetProvider(projet: Projet){

    let images = null;
    /* if( projet.images !== [] && projet.images.length !== 0)
    images = projet.images; */

    let id_cat: number[];
    id_cat = [];

    if ( projet.categories !== undefined && projet.categories !== null) {
      for ( let i = 0; i < projet.categories.length; i++) {
        id_cat.push(projet.categories[i].id);
      }
    }


    const body=  {
      titre: projet.titre,
      description: projet.description,
      slug: projet.slug,
      isPublish: projet.is_publish,
      datePublish: projet.date_publish,
      photoSelected: projet.photo,
      imagesSelected: images,
      categories: id_cat,
               
     };

     const httpOptions = {
       headers: new HttpHeaders({
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };

     var donnees = JSON.stringify(body);
     
     return this.httpClient.patch(Config.apiUrl+ 'admin/projets' + '/' + projet.id,donnees,httpOptions);
  
   }




   getOnePageProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get(Config.apiUrl+ 'admin/pages'+'/'+id,httpOptions);
  }


  getOneProjetProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get(Config.apiUrl+ 'admin/projets'+'/'+id,httpOptions);

  }




  getAllPageProvider(){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get<Page[]>(Config.apiUrl+ 'admin/pages',httpOptions);
  }


  getAllMessagesProvider(){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get<Message[]>(Config.apiUrl+ 'admin/messages',httpOptions);
  }

  getAllSouscriptionProvider(){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get<Souscription[]>(Config.apiUrl+ 'admin/souscriptions',httpOptions);
  }

  


  deleteMessageProvider(id){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.delete(Config.apiUrl+ 'admin/messages'+'/'+id,httpOptions);
  }


  getOneMessageProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get(Config.apiUrl+ 'admin/messages'+'/'+id,httpOptions);
  }

  getOneSouscriptionProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Souscription>(Config.apiUrl+ 'admin/souscriptions'+'/'+id,httpOptions);

  }

  getAllProjetProvider(){

    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Projet[]>(Config.apiUrl+ 'admin/projets',httpOptions);

  }


  


  updateParametresGeneralProvider(param: Settings){

   
    /* const body=  {
      titre: title,
      description:desc,
      slogan: slo,
      map:mp,
      email:em,
      telephone:phone,
      adresse:addr,
      logo:log
               
     }; */
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     // var donnees = JSON.stringify(body);
    
    return this.httpClient.patch(Config.apiUrl+ 'settings/general',param,httpOptions);
  }



  updateParametresStatProvider(invest?,prog?,pj?){

   
    const body=  {
     investisseurs:invest,
     programmes:prog,
     projets:pj
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
    
   return this.httpClient.patch(Config.apiUrl+ 'settings/stat',donnees,httpOptions);
  }


  getParametresStatProvider(){

   
   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value  
        
      })
    };
  
   
  return this.httpClient.get(Config.apiUrl+ 'settings/stat',httpOptions);
 }


  getParametresGeneralProvider(){

   
   
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  
         
       })
     };
   
    
   return this.httpClient.get(Config.apiUrl+ 'settings/general',httpOptions);
  }


  getParametresNetworkProvider(){

   
   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value  
        
      })
    };
  
   
  return this.httpClient.get(Config.apiUrl+ 'settings/network',httpOptions);
 }




  updateParametresNetworkProvider(f?, t?,v?,p?,y?,l?,inst?){

   
    const body=  {
      facebook: f,
      twitter:t,
      viadeo: v,
      pinterest:p,
      youtube:y,
      linkedin:l,
      instagram:inst,
      
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value  ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = JSON.stringify(body);
    
   return this.httpClient.patch(Config.apiUrl+ 'settings/network',donnees,httpOptions);
  }


  updateParametresMenuProvider(m?, f1?, f2?,f3?,arch?){

   
    const body=  {
     main:m,
     footer1:f1,
     footer2:f2,
     footer3:f3,
      archive:arch
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = body
    
   return this.httpClient.patch(Config.apiUrl+ 'settings/menu',donnees,httpOptions);
  }

  getMenuParametersProvider(){

   
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
   return this.httpClient.get(Config.apiUrl+ 'settings/menu',httpOptions);
  }


  updateParametresPagesProvider(ap?, vs?, ms?,act?,prg?,egb?,souscrp?,reclam?,econo?,crea?,org?,promo?){

   
    const body=  {
    apropos:ap,
    vision:vs,
    mission:ms,
    actionnariat:act,
    programme:prg,
    egibilite:egb,
    souscription:souscrp,
    reclamation:reclam,
    economie:econo,
    creation:crea,
    organisation:org,
    promotion:promo
               
     };
     const httpOptions = {
       headers: new HttpHeaders({
        
         'X-Auth-Token': this.authService.token.value ,
         'Content-Type':  'application/json'     
       })
     };
     var donnees = body
    
   return this.httpClient.patch(Config.apiUrl+ 'settings/page',donnees,httpOptions);
  }


  getPageProvider(){

      
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value  
        
      })
    };
  
   
  return this.httpClient.get(Config.apiUrl+ 'settings/page',httpOptions);
    }


    getMenuProvider(){

      
    const httpOptions = {
      headers: new HttpHeaders({
       
        'X-Auth-Token': this.authService.token.value  
        
      })
    };
  
   
  return this.httpClient.get(Config.apiUrl+ 'settings/menu',httpOptions);
    }



    /************************************* api critère **********************************************************/

    addCritereProvider(data: Critere){

        const body=  {
          label: data.label,
          typeCritere: data.type_critere,
          description: data.description,
          shortDescription: data.short_description,
          photoSelected: data.photo,

        };
        
        const httpOptions = {
          headers: new HttpHeaders({
            
            'X-Auth-Token': this.authService.token.value  ,
            'Content-Type':  'application/json'     
          })
        };
    
        var donnees = JSON.stringify(body);
        
        return this.httpClient.post(Config.apiUrl+ 'admin/criteres', donnees,httpOptions);
      
    }
    
    deleteCritereProvider(id){
    
        const httpOptions = {
          headers: new HttpHeaders({
          
            'X-Auth-Token': this.authService.token.value    
          })
        };
        
        return this.httpClient.delete(Config.apiUrl+ 'admin/criteres'+'/'+id,httpOptions);
    
    }
    
    getOneCritereProvider(id){
    
        const httpOptions = {
          headers: new HttpHeaders({
          
            'X-Auth-Token': this.authService.token.value    
          })
        };
        
        return this.httpClient.get(Config.apiUrl+ 'admin/criteres'+'/'+id,httpOptions);
    
    }

  updateCritereProvider(data: Critere){

      
        const body=  {
        label: data.label,
        typeCritere: data.type_critere,
        description: data.description,
        shortDescription: data.short_description,
        photoSelected: data.photo,
                  
        };

        const httpOptions = {
          headers: new HttpHeaders({
          
            'X-Auth-Token': this.authService.token.value  ,
            'Content-Type':  'application/json'     
          })
        };
        
        var donnees = JSON.stringify(body);
      
        return this.httpClient.patch(Config.apiUrl+ 'admin/criteres'+'/'+data.id,donnees,httpOptions);
  }
    
  getAllCritereProvider(type: string){

      const httpOptions = {
        headers: new HttpHeaders({
          'X-Auth-Token': this.authService.token.value    
        })
      };
      // console.log('admin/criteres?type=' + type);
      return this.httpClient.get<Critere[]>(Config.apiUrl+ 'admin/criteres?type=' + type, httpOptions);

  }


  /*********************************************** API FORMATION ***********************************************************/


  addFormationProvider(data: Formation){

      const body=  {
        titre: data.titre,
        description: data.description,
        slug: data.slug,
        isPublish: data.is_publish,
        parent: (data.parent !== null && data.parent !== undefined) ? data.parent.id : null,
        categorie: data.categorie,
        /*datePublish: data.date_publish,*/
        photoSelected: data.photo,
        //categories:cat
      };
      
      const httpOptions = {
        headers: new HttpHeaders({
          
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };

      var donnees = JSON.stringify(body);
      
      return this.httpClient.post(Config.apiUrl+ 'admin/formations', donnees,httpOptions);
    
  }

  deleteFormationProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.delete(Config.apiUrl+ 'admin/formations'+'/'+id,httpOptions);

  }

  getOneFormationProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.get(Config.apiUrl+ 'admin/formations'+'/'+id,httpOptions);

  }

  updateFormationProvider(data: Formation){

      const body=  {
        titre: data.titre,
        description: data.description,
        slug: data.slug,
        isPublish: data.is_publish,
        parent: (data.parent !== null && data.parent !== undefined) ? data.parent.id : null,
        categorie: data.categorie,
        /*datePublish: data.date_publish,*/
        photoSelected: data.photo,
        //categories:cat
      };
     /* const body=  {
      titre: data.titre,
      description: data.description,
      parent: data.parent,
      cycle: data.cycle,
      admissibilite: data.admissibilite,
      slug: data.slug,
      isPublish: data.is_publish,
      datePublish: data.date_publish,
      photoSelected: data.photo,
      //categories:cat
     };
 */
      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };
      
      var donnees = JSON.stringify(body);
    
      return this.httpClient.patch(Config.apiUrl+ 'admin/formations'+'/'+data.id,donnees,httpOptions);
  }

  getAllformationProvider(type: string){

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Formation[]>(Config.apiUrl+ 'admin/formations?type=' + type, httpOptions);

  }


  /************************************************************ API ECOLES ******************************************************************/

  addEcoleProvider(data: Ecole){

      let images = null;
      if( data.images !== null && data.images !== undefined && data.images.length !== 0)
      images = data.images;
      


      const body=  {
        titre: data.titre,
        description: data.description,
        slug: data.slug,
        isPublish: data.is_publish,
        /*datePublish: data.date_publish,*/
        photoSelected: data.photo,
        imagesSelected: images,
        nom: data.titre,
        promoteur: data.promoteur,
        autorisationCreation: data.autorisation_creation,
        autorisationOuverture: data.autorisation_ouverture,
        pays: data.pays,
        adresse: data.adresse,
        bp: data.bp,
        tel: data.tel,
        fax: data.fax,
        email: data.email,
        website: data.website,
        videoYoube: data.video_youtube,
        type: data.type,
        particularities: data.particularities,
        partenaires: data.partenaires,
        secteur: data.secteur,
        abreviation: data.abreviation,
        whatsapp: data.whatsapp,
        facebook: data.facebook,
        linkedln: data.linkedln,
        twitter: data.twitter,
        mapscode: data.mapscode,
        isTop: data.is_top,
        //categories:cat
      };
      
      const httpOptions = {
        headers: new HttpHeaders({
          
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };

      var donnees = JSON.stringify(body);
      
      return this.httpClient.post(Config.apiUrl+ 'admin/ecoles', donnees,httpOptions);
    
  }

  deleteEcoleProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.delete(Config.apiUrl+ 'admin/ecoles'+'/'+id,httpOptions);

  }

  getOneEcoleProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.get(Config.apiUrl+ 'admin/ecoles'+'/'+id,httpOptions);

  }

  updateEcoleProvider(data: Ecole){

      let images = null;
      if( data.images !== null && data.images !== undefined && data.images.length !== 0)
      images = data.images;
      

      const body=  {
        titre: data.titre,
        description: data.description,
        slug: data.slug,
        isPublish: data.is_publish,
        /*datePublish: data.date_publish,*/
        photoSelected: data.photo,
        imagesSelected: images,
        nom: data.titre,
        promoteur: data.promoteur,
        autorisationCreation: data.autorisation_creation,
        autorisationOuverture: data.autorisation_ouverture,
        pays: data.pays,
        adresse: data.adresse,
        bp: data.bp,
        tel: data.tel,
        fax: data.fax,
        email: data.email,
        website: data.website,
        videoYoutube: data.video_youtube,
        type: data.type,
        particularities: data.particularities,
        partenaires: data.partenaires,
        secteur: data.secteur,
        abreviation: data.abreviation,
        whatsapp: data.whatsapp,
        facebook: data.facebook,
        linkedln: data.linkedln,
        twitter: data.twitter,
        mapscode: data.mapscode,
        isTop: data.is_top,
        //categories:cat
      };
    /* const body=  {
      titre: data.titre,
      description: data.description,
      parent: data.parent,
      cycle: data.cycle,
      admissibilite: data.admissibilite,
      slug: data.slug,
      isPublish: data.is_publish,
      datePublish: data.date_publish,
      photoSelected: data.photo,
      //categories:cat
    };
  */
      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };
      
      var donnees = JSON.stringify(body);
    
      return this.httpClient.patch(Config.apiUrl+ 'admin/ecoles'+'/'+data.id,donnees,httpOptions);
  }

  getAllEcoleProvider(type: string){

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get<Ecole[]>(Config.apiUrl+ 'admin/ecoles?type=' + type, httpOptions);

  }

  /************************************************************ API ADMISSION ******************************************************************/

  addAdmissionProvider(ecole, data: Admission){

      let id_formations: number[] = [];


      if ( data.formations !== undefined && data.formations !== null && data.formations.length > 0 ) {

        // id_formations = [];

        for ( let i = 0; i < data.formations.length; i++) {
          id_formations.push(data.formations[i].id);
        }

      }


      const body=  {
        
        formations: id_formations,
        cycle: data.cycle,
        admissibilite: data.admissibilite,
        moisRentree: data.mois_rentree,
        niveauRequis: data.niveau_requis,
        faculte: data.faculte
        //categories:cat
      };
      
      const httpOptions = {
        headers: new HttpHeaders({
          
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };

      var donnees = JSON.stringify(body);
      
      return this.httpClient.post(Config.apiUrl+ 'admin/admissions?ecole=' + ecole, donnees,httpOptions);
    
  }

  deleteAdmissionProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.delete(Config.apiUrl+ 'admin/admissions'+'/'+id,httpOptions);

  }

  getOneAdmissionProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.get(Config.apiUrl+ 'admin/admissions'+'/'+id,httpOptions);

  }

  updateAdmissionProvider(data: Admission){

      let id_formations: number[] = [];


      if ( data.formations !== undefined && data.formations !== null && data.formations.length > 0 ) {

        // id_formations = [];

        for ( let i = 0; i < data.formations.length; i++) {
          id_formations.push(data.formations[i].id);
        }

      }

      const body=  {
        formations: id_formations,
        cycle: data.cycle,
        admissibilite: data.admissibilite,
        moisRentree: data.mois_rentree,
        niveauRequis: data.niveau_requis,
        faculte: data.faculte
        //categories:cat
      };
    /* const body=  {
      titre: data.titre,
      description: data.description,
      parent: data.parent,
      cycle: data.cycle,
      admissibilite: data.admissibilite,
      slug: data.slug,
      isPublish: data.is_publish,
      datePublish: data.date_publish,
      photoSelected: data.photo,
      //categories:cat
    };
  */
      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };
      
      var donnees = JSON.stringify(body);
    
      return this.httpClient.patch(Config.apiUrl+ 'admin/admissions'+'/'+data.id,donnees,httpOptions);
  }

  
  
  /************************************************************ FACULTES ******************************************************************/

  addFaculteProvider(data: Faculte){

      const body=  {
        nom: data.nom,
        tel: data.tel,
        email: data.email,
        website: data.website,
        ecole: data.ecole
        //categories:cat
      };
      
      const httpOptions = {
        headers: new HttpHeaders({
          
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };

      var donnees = JSON.stringify(body);
      
      return this.httpClient.post(Config.apiUrl+ 'admin/facultes', donnees,httpOptions);
    
  }

  deleteFaculteProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.delete(Config.apiUrl+ 'admin/facultes'+'/'+id,httpOptions);

  }

  getOneFaculteProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.get(Config.apiUrl+ 'admin/facultes'+'/'+id,httpOptions);

  }

  updateFaculteProvider(data: Faculte){

      

    const body=  {
      nom: data.nom,
      tel: data.tel,
      email: data.email,
      website: data.website,
      // ecole: data.ecole
      //categories:cat
    };

    /* const body=  {
      titre: data.titre,
      description: data.description,
      parent: data.parent,
      cycle: data.cycle,
      admissibilite: data.admissibilite,
      slug: data.slug,
      isPublish: data.is_publish,
      datePublish: data.date_publish,
      photoSelected: data.photo,
      //categories:cat
    };
  */
      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };
      
      var donnees = JSON.stringify(body);
    
      return this.httpClient.patch(Config.apiUrl+ 'admin/facultes'+'/'+data.id,donnees,httpOptions);
  }

  /************************************************************ METIER ******************************************************************/
  
  addMetierProvider(data: Metier){

      const body=  {
        titre: data.titre,
        description: data.description,
        slug: data.slug,
        isPublish: data.is_publish,
        secteur: data.secteur,
        niveau: data.niveau,
        salaire: data.salaire,
        alternance: data.alternance,
        selectivite: data.selectivite,
        insertion: data.insertion,
        photoSelected: data.photo,
        photoVideoSelected: data.image_video,
        videoYoutube: data.video_youtube,
        //categories:cat
      };
      
      const httpOptions = {
        headers: new HttpHeaders({
          
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };

      var donnees = JSON.stringify(body);
      
      return this.httpClient.post(Config.apiUrl+ 'admin/metiers', donnees,httpOptions);
    
  }

  deleteMetierProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.delete(Config.apiUrl+ 'admin/metiers'+'/'+id,httpOptions);

  }

  getOneMetierProvider(id){

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value    
        })
      };
      
      return this.httpClient.get(Config.apiUrl+ 'admin/metiers'+'/'+id,httpOptions);

  }

  updateMetierProvider(data: Metier){

    const body=  {
      titre: data.titre,
      description: data.description,
      slug: data.slug,
      isPublish: data.is_publish,
      secteur: data.secteur,
      niveau: data.niveau,
      salaire: data.salaire,
      alternance: data.alternance,
      selectivite: data.selectivite,
      insertion: data.insertion,
      photoSelected: data.photo,
      photoVideoSelected: data.image_video,
      videoYoutube: data.video_youtube
      //categories:cat
    };

      /* const body=  {
          titre: data.titre,
          description: data.description,
          parent: data.parent,
          cycle: data.cycle,
          admissibilite: data.admissibilite,
          slug: data.slug,
          isPublish: data.is_publish,
          datePublish: data.date_publish,
          photoSelected: data.photo,
          //categories:cat
        };
      */

      const httpOptions = {
        headers: new HttpHeaders({
        
          'X-Auth-Token': this.authService.token.value  ,
          'Content-Type':  'application/json'     
        })
      };
      
      var donnees = JSON.stringify(body);
    
      return this.httpClient.patch(Config.apiUrl+ 'admin/metiers'+'/'+data.id,donnees,httpOptions);
  }


  getAllmetierProvider(type: string){

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value    
      })
    };
  
    return this.httpClient.get<Metier[]>(Config.apiUrl+ 'admin/metiers?type=' + type, httpOptions);

  }



  /************************************************************ JOBS ******************************************************************/
  
  addJobProvider(data: Job){

    const body=  {
      titre: data.titre,
      description: data.description,
      slug: data.slug,
      isPublish: data.is_publish,
      periode: data.periode,
      localisation: data.localisation,
      profil: data.profil,
      postulation: data.postulation,
      nbrPoste: data.nbr_poste,
      typeContrat: data.type_contrat,
      domaine: data.domaine,
      photoSelected: data.photo,
      renumeration: data.renumeration,
      enterprise: data.enterprise,
      //categories:cat
    };
    
    const httpOptions = {
      headers: new HttpHeaders({
        
        'X-Auth-Token': this.authService.token.value  ,
        'Content-Type':  'application/json'     
      })
    };

    var donnees = JSON.stringify(body);
    
    return this.httpClient.post(Config.apiUrl+ 'admin/jobs', donnees,httpOptions);
  
}

deleteJobProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
      
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.delete(Config.apiUrl+ 'admin/jobs'+'/'+id,httpOptions);

}

getOneJobProvider(id){

    const httpOptions = {
      headers: new HttpHeaders({
      
        'X-Auth-Token': this.authService.token.value    
      })
    };
    
    return this.httpClient.get(Config.apiUrl+ 'admin/jobs'+'/'+id,httpOptions);

}

updateJobProvider(data: Job){

  const body=  {
      titre: data.titre,
      description: data.description,
      slug: data.slug,
      isPublish: data.is_publish,
      periode: data.periode,
      localisation: data.localisation,
      profil: data.profil,
      postulation: data.postulation,
      nbrPoste: data.nbr_poste,
      typeContrat: data.type_contrat,
      domaine: data.domaine,
      photoSelected: data.photo,
      renumeration: data.renumeration,
      enterprise: data.enterprise,
    //categories:cat
  };

    /* const body=  {
        titre: data.titre,
        description: data.description,
        parent: data.parent,
        cycle: data.cycle,
        admissibilite: data.admissibilite,
        slug: data.slug,
        isPublish: data.is_publish,
        datePublish: data.date_publish,
        photoSelected: data.photo,
        //categories:cat
      };
    */

    const httpOptions = {
      headers: new HttpHeaders({
      
        'X-Auth-Token': this.authService.token.value  ,
        'Content-Type':  'application/json'     
      })
    };
    
    var donnees = JSON.stringify(body);
  
    return this.httpClient.patch(Config.apiUrl+ 'admin/jobs'+'/'+data.id,donnees,httpOptions);
}


getAlljobProvider(){

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.get<Job[]>(Config.apiUrl+ 'admin/jobs', httpOptions);

}


/*********************************************** API LICENCE ***********************************************************/

addLicenceProvider(data: LicenceKey){

  // console.log(data);

  const body=  {
    activated: data.activated,
    nbrActivation: data.nbr_activation,
    nbrJour: data.nbr_jour,
    nbrDataBase: data.nbr_data_base
  };
  
  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value,
      'Content-Type':  'application/json'     
    })
  };

  var donnees = JSON.stringify(body);
  
  return this.httpClient.post(Config.apiUrl+ 'admin/licencekeys', donnees,httpOptions);

}

deleteLicenceProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.delete(Config.apiUrl+ 'admin/licencekeys'+'/'+id,httpOptions);

}

getOneLicenceProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.get(Config.apiUrl+ 'admin/licencekeys'+'/'+id,httpOptions);

}

updateLicenceProvider(data: LicenceKey){

  const body = {
    activated: data.activated,
    nbrActivation: data.nbr_activation,
    nbrJour: data.nbr_jour,
    nbrDataBase: data.nbr_data_base
  };

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value  ,
      'Content-Type':  'application/json'     
    })
  };
  
  var donnees = JSON.stringify(body);

  return this.httpClient.patch(Config.apiUrl+ 'admin/licencekeys'+'/'+data.id,donnees,httpOptions);

}

getAllLicenceProvider(){

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.get<LicenceKey[]>(Config.apiUrl+ 'admin/licencekeys', httpOptions);

}


/*********************************************** API OFFRE ***********************************************************/

addOffreProvider(data: Offre){

  // console.log(data);

  const body=  {
    titre: data.titre,
    description: data.description,
    prix: data.prix,
    nbrJour: data.nbr_jour,
    nbrDataBase: data.nbr_data_base,
    isPublish: data.is_publish,
    descriptionDuree: data.description_duree,
    nbrActivation: data.nbr_activation
  };
  
  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value,
      'Content-Type':  'application/json'     
    })
  };

  var donnees = JSON.stringify(body);
  
  return this.httpClient.post(Config.apiUrl+ 'admin/offres', donnees,httpOptions);

}

deleteOffreProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.delete(Config.apiUrl+ 'admin/offres'+'/'+id,httpOptions);

}

getOneOffreProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.get(Config.apiUrl+ 'admin/offres'+'/'+id,httpOptions);

}

updateOffreProvider(data: Offre){

  const body=  {
    titre: data.titre,
    description: data.description,
    prix: data.prix,
    nbrJour: data.nbr_jour,
    nbrDataBase: data.nbr_data_base,
    isPublish: data.is_publish,
    descriptionDuree: data.description_duree,
    nbrActivation: data.nbr_activation
  };

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value  ,
      'Content-Type':  'application/json'     
    })
  };
  
  var donnees = JSON.stringify(body);

  return this.httpClient.patch(Config.apiUrl+ 'admin/offres'+'/'+data.id,donnees,httpOptions);

}


getAllOffreProvider(){

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.get<Offre[]>(Config.apiUrl+ 'offres', httpOptions);

}


/************************************************************ API device ******************************************************************/

getDevices() {
  
  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.get<Device[]>(Config.apiUrl+ 'admin/devices',  httpOptions);

}

save(device: Device) {

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Auth-Token': this.authService.token.value    
      })
    };

    const dev = {
        /* firebaseToken: device.firebase_token,
        browser: device.browser,
        browserVersion: device.browser_version,
        os: device.os,
        osVersion: device.os_version,
        type: device.type,
        lang: device.lang,
        countryCode: device.country_code,
        countryName: device.country_name,
        latitude: device.latitude,
        longitude: device.longitude,
        city: device.city,
        ipv4: device.ipv4, */
        name: device.name,
    };
    

    return this.httpClient.patch(Config.apiUrl+ 'admin/devices/' + device.id, dev, httpOptions);
        
    


}

deleteDevice(device: Device) {

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.delete(Config.apiUrl+ 'admin/devices/' + device.id, httpOptions);

}


/*********************************************** API DATABASE ***********************************************************/

addDataBaseProvider(data: Database){

  // console.log(data);

  const body=  {
    description: data.description,
    remote: data.remote,
    syncMode: data.syncMode
  };
  
  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value,
      'Content-Type':  'application/json'     
    })
  };

  var donnees = JSON.stringify(body);
  
  return this.httpClient.post(Config.apiUrl+ 'admin/databases', donnees,httpOptions);

}

deleteDatabaseProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.delete(Config.apiUrl+ 'admin/databases'+'/'+id,httpOptions);

}

getOneDatabaseProvider(id){

  const httpOptions = {
    headers: new HttpHeaders({
    
      'X-Auth-Token': this.authService.token.value    
    })
  };
  
  return this.httpClient.get(Config.apiUrl+ 'admin/databases'+'/'+id,httpOptions);

}

updateDatabaseProvider(data: Database){

  const body = {
    description: data.description,
    remote: data.remote,
    syncMode: data.syncMode
  };

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value  ,
      'Content-Type':  'application/json'     
    })
  };
  
  var donnees = JSON.stringify(body);

  return this.httpClient.patch(Config.apiUrl+ 'admin/databases'+'/'+data.id,donnees,httpOptions);

}

getAllDatabasesProvider(){

  const httpOptions = {
    headers: new HttpHeaders({
      'X-Auth-Token': this.authService.token.value    
    })
  };

  return this.httpClient.get<Database[]>(Config.apiUrl+ 'admin/databases', httpOptions);

}




}
